import { isObject } from 'lodash'

export let registeredTableHandlers = {}

export function registerHandlers (handlers) {
  if (handlers && isObject(handlers)) {
    registeredTableHandlers = {
      ...registeredTableHandlers,
      ...handlers
    }
  }
}

export function unregisterHandlers (key) {
  if (key && registeredTableHandlers[key]) {
    delete registeredTableHandlers[key]
  }
}
